import { Suspense } from "react";

import { useTranslations } from "next-intl";

import { type ServerDataOutput } from "../data.subscription-data";
import {
  BuyNowButtonWithParams,
  BuyNowDisplay,
  type Translation,
} from "./ui.selector-buy-now-button-client";

interface BuyNowButtonProps {
  data: ServerDataOutput;
}
export const BuyNowButton = (props: BuyNowButtonProps) => {
  const { data } = props;
  const t = useTranslations("stf_m_subscription.screen_subscription");
  const translation: Translation = {
    label: t("buy_now_button"),
  };

  return (
    <Suspense fallback={<BuyNowDisplay disabled t={translation} />}>
      <BuyNowButtonWithParams data={data} t={translation} />
    </Suspense>
  );
};
